/* src/app/modules/print-cards/components/cut-lines/print-card-bottom-cut-lines/print-card-bottom-cut-lines.component.scss */
:host {
  flex: 1;
  display: flex;
  justify-content: center;
  z-index: 1;
}
.bottom-cut-lines {
  position: relative;
  height: 100%;
  max-height: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
}
.bottom-cut-lines.extended {
  max-height: none;
}
.bottom-cut-lines * {
  box-sizing: border-box;
}
.bottom-cut-lines .dividing-sliver-container {
  position: relative;
}
.bottom-cut-lines .dividing-sliver-container .dividing-sliver {
  position: relative;
  height: 100%;
  border-left: 1px solid black;
  border-right: 1px solid black;
}
.bottom-cut-lines .dividing-sliver-container .dividing-sliver-horizontal-left-line {
  position: absolute;
  align-self: center;
  border-bottom: 1px solid black;
}
.bottom-cut-lines .dividing-sliver-container .dividing-sliver-horizontal-middle-line {
  position: absolute;
  align-self: center;
  border-bottom: 1px solid black;
}
.bottom-cut-lines .dividing-sliver-container .dividing-sliver-horizontal-right-line {
  position: absolute;
  align-self: center;
  border-bottom: 1px solid black;
}
.bottom-left-corner {
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  flex: 1;
}
.bottom-left-corner .bottom-left-sliver-horizontal {
  position: absolute;
  border-top: 1px solid black;
  top: 0;
  left: 0;
}
.bottom-left-corner .bottom-left-sliver-vertical {
  position: absolute;
  border-left: 1px solid black;
  bottom: 0;
  right: 0;
}
.bottom-right-corner {
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  flex: 1;
}
.bottom-right-corner .bottom-right-sliver-horizontal {
  position: absolute;
  border-top: 1px solid black;
  top: 0;
  right: 0;
}
.bottom-right-corner .bottom-right-sliver-vertical {
  position: absolute;
  border-right: 1px solid black;
  bottom: 0;
  left: 0;
}
/*# sourceMappingURL=print-card-bottom-cut-lines.component.css.map */
